import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Col, Container, Navbar, Row } from 'react-bootstrap';
import { useHistory, withRouter } from 'react-router';
import styled, { useTheme } from 'styled-components';

import { AppContext } from '../../context/AppContext';
import { useCurrentUser } from '../../hooks';
import { signOut } from '../../utils/auth';
import AdminBar from '../AdminBar';
import Footer from '../Footer/Footer';
import IconButton from '../IconButton';
import MainNav from '../MainNav';

const StyledContainer = styled(Container)`
  min-height: 100vh;
  background: ${(props) => props.theme.colors.gradients.app};
`;

const StyledNavbar = styled(Navbar)`
  background: ${(props) => props.theme.colors.verticalgradients.header} !important;
  border-bottom: ${(props) => props.theme.navbar.headerBorder || 'none'};
`;

const SideBarCol = styled(Col)`
  border-right: ${(props) => props.theme.colors.light} 1px solid;
`;

const MainContentCol = styled(Col)`
  background: ${(props) => props.theme.colors.extraLight};
`;

const AppLayout = ({ children, location, hideSidebar }) => {
  const { showTariffRecommender, showSavings } = useContext(AppContext);
  const history = useHistory();
  const { user, isAdmin } = useCurrentUser();
  const theme = useTheme();

  // TODO: change this name to mpan onboarded to differentiate from optimiser
  // TODO: disable mpan checks as TDAS is not available
  // const [isOnboarded, setIsOnboarded] = useState(true);

  // useEffect(() => {
  //   getUserMpans()
  //     .then((userMpans) => setIsOnboarded(!!userMpans?.length))
  //     .catch((e) => setIsOnboarded(false));

  //   let observer;
  //   if (!!window.location.hash) {
  //     const targetId = window.location.hash.split('#')[1];

  //     observer = new MutationObserver(() => {
  //       const el = document.getElementById(targetId);
  //       if (el) {
  //         smoothScroll(targetId);
  //         observer.disconnect();
  //       }
  //     });

  //     observer.observe(document.body, {
  //       childList: true,
  //       subtree: true,
  //     });
  //   }

  //   return () => {
  //     observer?.disconnect();
  //   };
  // }, []);

  return (
    <>
      {isAdmin && <AdminBar user={user} onSignOut={signOut} />}
      <StyledContainer fluid className={`d-flex flex-column standard-layout`}>
        <Row>
          <Col className="p-0">
            <StyledNavbar collapseOnSelect expand="lg" bg="light" variant="light">
              <Container fluid="xl">
                <MainNav history={history} />
              </Container>
            </StyledNavbar>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center p-0 flex-fill">
          <Container fluid="xl" className="flex-fill">
            <Row className="h-100">
              {!hideSidebar && (
                <SideBarCol
                  xs={0}
                  sm={5}
                  md={4}
                  lg={4}
                  className="p-1 p-sm-2 p-md-3 p-lg-4 d-none d-lg-flex bg-white flex-column h-100"
                >
                  <div>
                    <IconButton href="/app/today" label="Today" icon={theme.navbar.mainNavIcons.today} />
                    {showSavings && (
                      <IconButton href="/app/savings" label="Savings" icon={theme.navbar.mainNavIcons.savings} />
                    )}
                    <IconButton
                      href="/app/energy-flow"
                      label="Energy Flow"
                      icon={theme.navbar.mainNavIcons.energyFlow}
                    />
                    {showTariffRecommender && (
                      <IconButton
                        href="/app/tariffs"
                        label="Tariff Recommender"
                        icon={theme.navbar.mainNavIcons.tariffRecommender}
                      />
                    )}
                    {/* // TODO: TDAS is not available at the moment
                    <IconButton 
                    href="/app/turn-down-and-save"
                    label="Turn Down and Save"
                    icon="tdas"
                    /> */}
                    <IconButton href="/app/settings" label="Settings" icon={theme.navbar.mainNavIcons.settings} />
                    <IconButton href="/app/help" label="Help" icon={theme.navbar.mainNavIcons.help} />
                  </div>
                  <div className="d-flex flex-column h-100 justify-content-between">
                    <div />
                  </div>
                </SideBarCol>
              )}
              <MainContentCol className="p-1 p-sm-2 p-md-3 p-lg-4 main-content-column">{children}</MainContentCol>
            </Row>
          </Container>
        </Row>
        <Footer location={location} />
      </StyledContainer>
    </>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  hideSidebar: PropTypes.bool,
  background: PropTypes.string,
};

export default withRouter(AppLayout);
